import { render, staticRenderFns } from "./YesNoModal.vue?vue&type=template&id=8b24da06"
import script from "./YesNoModal.vue?vue&type=script&lang=js"
export * from "./YesNoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports